<div class="d-flex justify-content-between">
  <label class="contacts-label font-medium" for="contacts">
    {{ label }}
  </label>
</div>
<div class="pb-50">
  <sk-tags-input-email
    initialMode="write" 
    [tags]="[getContactValue()]"
    [allowMultipleTags]="false"
    [disabled]="true">
  </sk-tags-input-email>
  <small class="text-muted">{{ helpText }}</small>
</div>